import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
import { Validator } from 'vee-validate';
import enLocale from '@/locale/en';

const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages: { en: enLocale },
    silentTranslationWarn: process.env.NODE_ENV === 'production',
});

const loadedLanguages = ['en'];

const setI18nLanguage = (locale) => {
    i18n.locale = locale;
    return locale;
};

const loadLanguageAsync = (locale) => {
    if (i18n.locale === locale) {
        return Promise.resolve(locale);
    }
    if (loadedLanguages.includes(locale)) {
        return Promise.resolve(setI18nLanguage(locale));
    }
    return import(/* webpackChunkName: "locale-[request]" */ `@/locale/${locale}`)
        .then(({ default: dictionary }) => {
            i18n.setLocaleMessage(locale, dictionary);
            loadedLanguages.push(locale);
            Validator.localize(locale, dictionary.validation);
            return setI18nLanguage(locale);
        });
};

export {
    i18n,
    loadedLanguages,
    loadLanguageAsync,
};
